import { t } from "@ebay/i18n-ebay";
import { getPropsForClickTracking } from "../../utils/tracking";
import type { MapContext } from "../map/types";

<context|ctx| from="map">
  $ const { handleWatchListItemToggle, watchListItems } = (ctx || {}) as MapContext;
  <div data-testid="items-left-rail" class=["items-left-rail", input.isLeftRailItemHover && "items-left-rail__hovering"]>
    <if(input.isLoading)>
      <items-left-rail-skeleton/>
    </if>

    <if(!input.isLoading && input.leftRailItems?.length > 0 && !input.showErrorMessage)>
      <ul>
        <for|item, index| of=input.pointsOfInterest>
          <if(item.itemCard)>
            $ const isHighlighted = input.highlightedItem === index;
            $ const isSelected = input.selectedItems.indexOf(index) !== -1 && !input.isPreviewCardEnabled;
            $ const isVisible = input.leftRailItems.some((leftRailItem) => item.itemCard?.card.listingId === leftRailItem.itemCard?.card.listingId);

            <left-rail-item
              index=index
              selectionState=(isSelected ? "selected" : isHighlighted ? "highlighted" : "unselected")
              model=item.itemCard
              isVisible=isVisible
              watchListItems=watchListItems
              handleWatchListItemToggle=handleWatchListItemToggle
              on-item-hover("onItemHover")
              on-unhover-item("onUnhoverItem")
            />
          </if>
        </for>
      </ul>
    </if>
    <if(!input.isLoading && (input.leftRailItems?.length < 1 || input.showErrorMessage))>
      <div class="items-left-rail-no-results" data-testid="left-rail-no-results">
        <ebay-page-notice class="items-left-rail-empty-notice" status="education">
          <p>${t("mapview/map", input.areFiltersActive ? "noFilteredItemsMessage" : "loadMoreErrorMessage")}</p>
        </ebay-page-notice>
      </div>
    </if>

    <if(input.cta && !input.isLoading && input.leftRailItems.length < input.pointsOfInterest.length)>
      <div class="items-left-rail__cta">
        <ebay-button on-click("onCtaClick") ...getPropsForClickTracking(input.cta?.action?.trackingList)>
          ${input?.cta?.text}
        </ebay-button>
      </div>
    </if>
  </div>
</context>
